import { render } from "./yc-header.vue?vue&type=template&id=18dd2d04&scoped=true"
import script from "./yc-header.vue?vue&type=script&lang=js"
export * from "./yc-header.vue?vue&type=script&lang=js"

import "./yc-header.vue?vue&type=style&index=0&id=18dd2d04&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18dd2d04"]])

export default __exports__